import { MutableRefObject, useCallback } from 'react';
import { eventListenerTypeEnum, useEventListener } from './useEventListener';

/**
 * @see https://usehooks.com/useOnClickOutside/
 */
export function useOnClickOutside(ref: MutableRefObject<any>, handler: Function) {
    const listener = useCallback(
        (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                handler(event);
            }
        },
        [ref, handler]
    );

    useEventListener(eventListenerTypeEnum.mousedown, listener);
    useEventListener(eventListenerTypeEnum.touchstart, listener);
}
